import axios from 'axios';

export const getSaleStats = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/sale-stats`);
export const getPastSettlements = (projectId, scope) =>
	axios.get(`/api/projects/${projectId}/dashboard/past-settlements`, {
		params: {
			...(scope ? { scope } : {}),
			...(scope === 'project' ? {} : { groupBy: 'project' })
		}
	});
export const getDueCommissionsStats = (projectId, userId) =>
	axios.get(`/api/projects/${projectId}/dashboard/due-commissions-stats/${userId}`);
function dashboardScopeParams(scope, range) {
	const params = {};
	if (scope === 'project') params.scope = 'project';
	if (range?.from) params.from = range.from;
	if (range?.to) params.to = range.to;
	return Object.keys(params).length ? params : undefined;
}

export const getOutstandingContracts = (projectId, scope, range) =>
	axios.get(`/api/projects/${projectId}/dashboard/outstanding-contracts`, {
		params: dashboardScopeParams(scope, range)
	});
export const getSaleStatuses = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/sale-statuses`);
export const getOverdueDeposits = (projectId, scope, range) =>
	axios.get(`/api/projects/${projectId}/dashboard/overdue-deposits`, {
		params: dashboardScopeParams(scope, range)
	});
export const getConditionalContracts = (projectId, scope, range) =>
	axios.get(`/api/projects/${projectId}/dashboard/conditional-contracts`, {
		params: dashboardScopeParams(scope, range)
	});
export const getSunsetDates = (projectId, scope, range) =>
	axios.get(`/api/projects/${projectId}/dashboard/sunset-dates`, {
		params: dashboardScopeParams(scope, range)
	});
export const getOverdueConditions = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/overdue-conditions`);
export const getSettlementDates = (projectId, scope, range) =>
	axios.get(`/api/projects/${projectId}/dashboard/settlement-dates`, {
		params: dashboardScopeParams(scope, range)
	});
export const getRemindersDashboard = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/reminders-dashboard`);
export const getNewEnquiries = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/new-enquiries`);
export const getRepeatEnquiry = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/repeat-enquiry`);
export const getFullDepositPaid = (projectId, scope) =>
	axios.get(`/api/projects/${projectId}/dashboard/full-deposits`, {
		params: scope ? { scope } : undefined
	});
export const getContractsExchange = (projectId, scope) =>
	axios.get(`/api/projects/${projectId}/dashboard/contracts-exchange`, {
		params: scope === 'project' ? { scope: 'project' } : undefined
	});
export const getCanceledSales = (projectId, scope) =>
	axios.get(`/api/projects/${projectId}/dashboard/canceled-sales`, {
		params: scope === 'project' ? { scope: 'project' } : undefined
	});
export const getWalkInStats = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/walk-in`);
export const fetchDashboardSettingsApi = (projectId, scope) =>
	axios.get(`/api/projects/${projectId}/dashboard/settings`, {
		params: { scope: scope === 'project' ? 'project' : 'business' }
	});
export const saveDashboardApi = ({ projectId, settings, scope }) =>
	axios.post(`/api/projects/${projectId}/dashboard/settings`, {
		settings,
		scope: scope === 'project' ? 'project' : 'business'
	});
export const addDashboardApi = (selectedProject, rest) =>
	axios.put(`/api/projects/${selectedProject}/dashboard/settings`, { rest });
export const getWeekSales = () => axios.get('/api/projects/dashboard/week-sales');
export const getWeekSignedContracts = () => axios.get('/api/projects/dashboard/signed-contracts');
export const getWeekEnquires = () => axios.get('/api/projects/dashboard/new-enquiries');
export const getWeekCancelations = () => axios.get('/api/projects/dashboard/week-cancelations');
export const getWeekOverdueDeposits = () =>
	axios.get('/api/projects/dashboard/week-overdue-deposits');
export const getWeekContactNotes = () => axios.get('/api/projects/dashboard/week-contact-notes');
export const getWeekToBeSignedContracts = () =>
	axios.get('/api/projects/dashboard/tobe-signed-contracts');
export const getProjectStatuses = ({ from, to } = {}) =>
	axios.get('/api/projects/dashboard/project-statuses', { params: { from, to } });
export const getListOverdueDeposits = () =>
	axios.get('/api/projects/dashboard/list-overdue-deposits');
export const fetchLotStatusDashboardApi = ({ ...rest }) =>
	axios.put('/api/projects/dashboard/dashboard-lot-stages', { ...rest });
export const getListToBeSignedContracts = () =>
	axios.get('/api/projects/dashboard/list-tobe-signed-contracts');
export const getOverdueContracts = () => axios.get('/api/projects/dashboard/overdue-contracts');
export const getUpcomingSettlements = () =>
	axios.get('/api/projects/dashboard/upcoming-settlements');
export const getWeeklySnapshot = ({ from, to, projectId } = {}) =>
	axios.get('/api/projects/dashboard/weekly-snapshot', {
		params: { from, to, projectId }
	});
export const getAnalyticsCharts = ({ projectId, scope, from, to } = {}) =>
	axios.get('/api/projects/dashboard/analytics-charts', {
		params: { projectId, scope, from, to }
	});
export const getMyTasksPreview = (projectId) =>
	axios.get(`/api/projects/${projectId}/dashboard/my-tasks`);
